angular.module('goodsAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'ngFileUpload']);



// WEBPACK FOOTER //
// ./src/app/goods-add/goods-add.module.js